/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Payout method
 */
export type PayoutMethod = typeof PayoutMethod[keyof typeof PayoutMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayoutMethod = {
  BANK_SWIFT: 'BANK_SWIFT',
  UNIONPAY: 'UNIONPAY',
} as const;
